import { INTEGRATION_CODE_BITRIX24 } from '../../../../common/constants';
import { Bitrix24Logo, Bitrix24SmallLogo } from './Bitrix24Logo';

export default {
  code: INTEGRATION_CODE_BITRIX24,
  logo: Bitrix24Logo,
  small_logo: Bitrix24SmallLogo,
};
